module.exports = __webpack_public_path__ + "static/media/proximaPergunta.99df652c.mp3";